import { AnswerHelper } from '..';

export const useAnswer = () => {
	let answerHelper = new AnswerHelper();
	return {
		answerHelper,
		activeAnswer: answerHelper.active()
	};
};
